// src/services/AgencyService.js
import ApiService from '../base/BaseApiService';

/**
 * 代理店データをIDで取得
 * @param {string|number} id - 代理店ID
 * @param {Object} options - オプション設定
 * @param {boolean} options.showErrorDialog - エラーダイアログを表示しない場合はfalse
 * @returns {Promise<Object>} 代理店データ
 */
export const fetchAgencyData = async (id, options = {}) => {
  try {
    const config = {};
    config.showErrorDialog = options.showErrorDialog;
    return await ApiService.get(`/agencies/${id}`, {}, config);
  } catch (error) {
    console.error('Error fetching agency data:', error);
    throw error;
  }
};

// 新しい代理店を作成
export const createAgency = async (agencyData) => {
  try {
    return await ApiService.post('/agencies/', agencyData);
  } catch (error) {
    console.error('Error creating agency:', error);
    throw error;
  }
};

// 既存の代理店を更新
export const updateAgency = async (id, agencyData) => {
  try {
    return await ApiService.put(`/agencies/${id}`, agencyData);
  } catch (error) {
    console.error('Error updating agency:', error);
    throw error;
  }
};

// 代理店を検索
export const searchAgency = async (params = {}) => {
  try {
    return await ApiService.post('/agencies/search', params);
  } catch (error) {
    console.error('Error fetching all agencies:', error);
    throw error;
  }
};